import PropTypes from 'prop-types';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import {injectIntl, intlShape} from 'react-intl';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject
} from '../reducers/project-state';
import {
    activateTab,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary
} from '../reducers/modals';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import SBFileUploaderHOC from '../lib/sb-file-uploader-hoc.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';
import systemPreferencesHOC from '../lib/system-preferences-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';
import {setIsScratchDesktop} from '../lib/isScratchDesktop.js';
import bindAll from 'lodash.bindall';

const {RequestMetadata, setMetadata, unsetMetadata} = storage.scratchFetch;

const setProjectIdMetadata = projectId => {
    // If project ID is '0' or zero, it's not a real project ID. In that case, remove the project ID metadata.
    // Same if it's null undefined.
    if (projectId && projectId !== '0') {
        setMetadata(RequestMetadata.ProjectId, projectId);
    } else {
        unsetMetadata(RequestMetadata.ProjectId);
    }
};

class GUI extends React.Component {

    // 新增constructor
    constructor (props) {
        super(props);
        this.state = {
            rscBaseUrl: 'http://10.100.160.253:9876',
            qid: '',
            userId: '',
            matchId: '',
            questionType: ''
        };
        // this.handleRscMessage = this.handleRscMessage.bind(this);
        bindAll(this, [
            'handleRscMessage',
            'checkForNewFile',
            'downloadProject'
        ]);
    }
    componentDidMount () {
        // 新增一行代码 所有备注代码都是作业-比赛需求
        // window.addEventListener('message', this.handleRscMessage);
        setIsScratchDesktop(this.props.isScratchDesktop);
        // 注释一行代码
        this.props.onStorageInit(storage);
        this.props.onVmInit(this.props.vm);
        // 更改了一行代码
        setProjectIdMetadata('');
        // setProjectIdMetadata('dada');
    }
    componentDidUpdate (prevProps, prevState) {

        if (this.props.projectId !== prevProps.projectId) {
            if (this.props.projectId !== null) {
                this.props.onUpdateProjectId(this.props.projectId);
            }
            setProjectIdMetadata(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }

        // 新增代码判断
        // if (prevState.qid !== '' && prevState.qid !== this.state.qid) {
        //     console.log('QID changed:', prevState.qid);
        //     if (this.state.questionType === '6'){
        //         this.downloadProject(this.state.userId, prevState.qid);
        //     }
        // }
    }

    // 新增代码
    // componentWillUnmount () {
    //     window.removeEventListener('message', this.handleRscMessage);
    // }

    // 新增接收消息
    handleRscMessage (event) {
        const data = event.data;
        if (data && typeof (data) === 'string' && data.includes('examId')) {
            const userId = JSON.parse(data).examId;
            const qid = JSON.parse(data).qid;
            const matchId = JSON.parse(data).matchId;
            const questionType = JSON.parse(data).questionType;
            // sessionStorage.setItem('examId', JSON.parse(data).examId);
            // sessionStorage.setItem('qid', JSON.parse(data).qid);
            this.setState({qid, userId, matchId, questionType}); // 更新 qid 状态
            this.checkForNewFile(userId, qid, matchId);
        } else {
            this.props.onStorageInit(storage);
        }
    }

    // 新增代码用于判断是否一上来就加载文件
    checkForNewFile = async (userId, qid, matchId) => {
        // eslint-disable-next-line max-len
        const url = `${this.state.rscBaseUrl}/competition/getScratchFile?competitionId=${matchId}&userId=${userId}&questionId=${qid}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const file = new File([blob], 'project.sb3', {
                type: 'application/octet-stream',
                lastModified: Date.now()
            });

            // 清除之前的空文件
            // this.props.vm.clear();
            const reader = new FileReader();
            reader.onload = event => {
                const data = new Uint8Array(event.target.result);
                this.props.vm.loadProject(data).then(() => {
                    this.props.onProjectLoaded();
                })
                    .catch(error => {
                        console.error('Failed to load project:', error);
                    });
            };
            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error('Error checking for new file:', error);
        }
    };

    // 新增自动保存的功能
    downloadProject = (userId, questionId) => {
        const url = `${this.state.rscBaseUrl}/competition/commitQues`;
        this.props.vm.saveProjectSb3().then(content => {
            // 上传文件到服务器
            this.uploadFile(url, content, userId, questionId);
        })
            .catch(error => {
                console.error('Failed to save project:', error);
            });
    };

    // 上传到后台
    uploadFile = (url, content, userId, questionId) => {
        const formData = new FormData();
        formData.append('competitionId', this.state.matchId);
        formData.append('questionId', questionId);
        formData.append('questionType', '6');
        formData.append('userId', userId);
        formData.append('scratchFile', new Blob([content], {type: 'application/octet-stream'}), 'examFile');
        fetch(url, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
            .then(data => {
                console.log('File uploaded successfully:', data);
            })
            .catch(error => {
                console.error('Failed to upload file:', error);
            });
    };

    render () {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired
};

GUI.defaultProps = {
    isScratchDesktop: false,
    isTotallyNormal: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => {},
    onUpdateProjectId: () => {},
    onVmInit: (/* vm */) => {}
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm
    };
};

const mapDispatchToProps = dispatch => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal())
});

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    SBFileUploaderHOC,
    // SBFileLocalUploader,
    cloudManagerHOC,
    systemPreferencesHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
